import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navbar as HeroUINavbar, NavbarBrand, NavbarContent, NavbarItem } from "@heroui/navbar";
import clsx from "clsx";
import { CircleUser } from "lucide-react";

export const Navbar = () => {
const navigate = useNavigate();
const [isMenuOpen, setIsMenuOpen] = useState(false);

return (
  <HeroUINavbar
    height="60px"
    isMenuOpen={isMenuOpen}
    onMenuOpenChange={setIsMenuOpen}
    classNames={{
      base: clsx(
        "rounded-b-3xl",
        "border-b border-black/10 dark:border-white/20",
        "text-gray-700 dark:text-gray-100",
        "bg-gray-100 dark:bg-black/40",
        "backdrop-blur-0 dark:backdrop-blur-xl",
        "shadow-[0_6px_20px_rgba(0,0,0,0.25)]"
      ),
      wrapper: "w-full justify-center",
      item: "hidden md:flex",
    }}
  >
    <NavbarBrand>
      <div className="rounded-full bg-foreground text-background">
        <img src="/logo.webp" width={36} alt="" />
      </div>
      <span className="ml-2 text-small font-medium">Notura</span>
    </NavbarBrand>

    <NavbarContent className="" justify="end">
      <NavbarItem onClick={() => navigate("/profile")} className="flex items-center gap-2 cursor-pointer">
        <CircleUser />
      </NavbarItem>
    </NavbarContent>
  </HeroUINavbar>
);
};